export default {
    notificationMsg:{
        msg:null,
        errorCode:0
    },
    headerTitle:{
        title:'',
        showBackIcon:false
    },
    unleashEnalbed:null
}
